import { log } from './config';
import { logGTM } from './google-tag-manager';
import { LogMsgKey } from './message';
import {
  RuntimeInjectingLogType,
  createLogObject,
  createGTMLogObject,
} from './structure';

export * from './message';

/**
 * カスタムログ関数を定義します。
 */
export const customLog = (info: unknown, key: LogMsgKey, runtime: RuntimeInjectingLogType) => {
  queueMicrotask(() => {
    try {
      const logObj = createLogObject(info, key, runtime);
      const { level } = logObj;
      log(level, logObj);

      if (import.meta.env.VITE_ENABLE_GOOGLE_ANALYTICS === 'true') {
        const gtmLogObj = createGTMLogObject(key, runtime);
        logGTM(level, gtmLogObj);
      }
    } catch (e) { /** ignore */ }
  });
};
